import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "src/store";

export interface Isurfshark {
  surfsharkFilter: {
    order_id: string;
    purchase_id: string;
    status: string;
    user_country: string;
    product_catalog_id: string;
    user_id: string;
    dateGte: string;
    dateLte: string;
  };
}

const initialState: Isurfshark = {
  surfsharkFilter: {
    order_id: "",
    purchase_id: "",
    status: "",
    user_country: "",
    product_catalog_id: "",
    user_id: "",
    dateGte: "",
    dateLte: "",
  },
};

type surfsharkFilter = {
  order_id: string;
  purchase_id: string;
  status: string;
  user_country: string;
  product_catalog_id: string;
  user_id: string;
  dateGte: string;
  dateLte: string;
};

export const surfsharkFilterSlice = createSlice({
  name: "thisSurfsharkFilter",
  initialState,
  reducers: {
    setSurfsharkFilter: (state, action: PayloadAction<surfsharkFilter>) => {
      state.surfsharkFilter = {
        ...state.surfsharkFilter,
        ...action.payload,
      };
    },
    reset: () => {
      return initialState;
    },
  },
});

export const { setSurfsharkFilter } = surfsharkFilterSlice.actions;

export const getSurfsharkFilter = (state: RootState) =>
  state.thisSurfsharkFilter.surfsharkFilter;

export default surfsharkFilterSlice.reducer;
